import router from '../../../router';
import Auth from "../../../utils/auth";

export default {
	name: 'ModuleBox',
	components: {

	},
	data(){
		return{
			ValueData:'111',
			Info:JSON.parse(Auth.getInfo()),
			
			MenuJsonData:[],

			DefaultActivePath:'',
		}
	},
	methods:{
		handleOpen(key, keyPath) {
			//console.log("打开:",key, keyPath);
		},
		handleClose(key, keyPath) {
			//console.log("关闭:",key, keyPath);
		},
		handSelect(key, keyPath) {
			//console.log("选择:",key, keyPath);
			router.replace({path:key});
		},	
	},
	mounted(){
		this.MenuJsonData = this.Info.Menu;

		//赋值当前路径
		this.DefaultActivePath = this.$route.path;
	},
    watch: {

    },
    emits:{

    }
}